import React, { useEffect } from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../config/firebase';

/**
 * Página de cierre de sesión SSO.
 * Se usa cuando el logout se inicia desde otra app: el backend redirige aquí,
 * cerramos Firebase y redirigimos a redirect_uri para que no quede sesión activa
 * y el usuario no vuelva a loguearse solo al pasar por el login.
 */
function LogoutPage() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const redirectUri = params.get('redirect_uri') || '/login';

    const doLogout = async () => {
      try {
        await signOut(auth);
      } catch (e) {
        console.warn('Firebase signOut:', e?.message);
      }
      window.location.replace(redirectUri);
    };

    doLogout();
  }, []);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      fontFamily: 'system-ui, sans-serif'
    }}>
      <p>Cerrando sesión...</p>
    </div>
  );
}

export default LogoutPage;
